import script from "./combo.vue?vue&type=script&setup=true&lang=js"
export * from "./combo.vue?vue&type=script&setup=true&lang=js"

import "./combo.vue?vue&type=style&index=0&id=651d1830&lang=scss"

const __exports__ = script;

export default __exports__